
import { defineComponent, computed, PropType } from 'vue';

type MessageSeverity = 'info' | 'success' | 'warning' | 'error';

export default defineComponent({
  name: 'SpmMessage',

  props: {
    severity: {
      type: String as PropType<MessageSeverity>,
      default: 'info',
      validator: (value: string) => ['info', 'success', 'warning', 'error'].includes(value),
    },

    closable: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: null,
    },
  },

  emits: ['close'],

  setup(props) {
    const iconClass = computed(() => {
      if (props.icon) return props.icon;

      const icons: Record<MessageSeverity, string> = {
        info: 'fa-solid fa-circle-info',
        success: 'fa-solid fa-circle-check',
        warning: 'fa-solid fa-triangle-exclamation',
        error: 'fa-solid fa-circle-xmark',
      };

      return icons[props.severity as MessageSeverity];
    });

    return {
      iconClass,
    };
  },
});
